import { PreserveNumberAlias } from './alias.utils';

export type SECONDS = number & PreserveNumberAlias;
export type MILLISECONDS = number & PreserveNumberAlias;
export type MINUTES = number & PreserveNumberAlias;
export type HOURS = number & PreserveNumberAlias;

export function getSeconds(hours: HOURS, minutes: MINUTES, seconds: SECONDS): SECONDS {
  return hours * 60 * 60 + (minutes || 0) * 60 + (seconds || 0) * 1;
}

export function getMilliseconds(hours: HOURS, minutes: MINUTES, seconds: SECONDS): MILLISECONDS {
  return getSeconds(hours, minutes, seconds) * 1000;
}
